import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiShieldCrown } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const AdministrationMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (!user.equinor) {
      return null;
    }

    if (
      !(
        user.is_developer ||
        user.can_administrate_some_user_group ||
        user.roles_names.includes("Assign Condition - View") ||
        user.roles_names.includes("Assignment Rules - View") ||
        user.roles_names.includes("Term - Create") ||
        user.roles_names.includes("Terms Exception - Create") ||
        user.roles_names.includes("Quotation Approval - Stats")
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="administration"
          onClick={() => handleClick("administration")}
          title={t("menu.administration.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiShieldCrown} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.administration.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon
            icon={openSubmenu.administration ? mdiChevronUp : mdiChevronDown}
          />
        </ListItemButton>
        <Collapse in={openSubmenu.administration} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {!!(user.is_developer || user.can_administrate_some_user_group) && (
              <HybridRouteListItemButtonLink
                caption="user groups"
                isReact={false}
                name="administration[userGroups]"
                sx={{ pl: 4 }}
                title={t("menu.administration.submenu.userGroups.title")}
                url="/administration/user_groups"
              >
                <ListItemText
                  primary={t("menu.administration.submenu.userGroups.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("Assign Condition - View") && (
              <HybridRouteListItemButtonLink
                caption="mm weekly goals"
                name="administration[mmWeeklyGoals]"
                sx={{ pl: 4 }}
                title={t("menu.administration.submenu.mmWeeklyGoals.title")}
                url="/mm_request_weekly_goals"
              >
                <ListItemText
                  primary={t("menu.administration.submenu.mmWeeklyGoals.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("Assignment Rules - View") && (
              <HybridRouteListItemButtonLink
                caption="mm request assignment rules"
                name="administration[mmRequestAssignmentRules]"
                sx={{ pl: 4 }}
                title={t(
                  "menu.administration.submenu.mmRequestAssignmentRules.title",
                )}
                url="/mm_request_assignment_rules"
              >
                <ListItemText
                  primary={t(
                    "menu.administration.submenu.mmRequestAssignmentRules.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("Term - Create") && (
              <HybridRouteListItemButtonLink
                caption="terms"
                name="administration[terms]"
                sx={{ pl: 4 }}
                title={t("menu.administration.submenu.terms.title")}
                url="/vsupplierregistration/terms"
              >
                <ListItemText
                  primary={t("menu.administration.submenu.terms.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("Terms Exception - Create") && (
              <HybridRouteListItemButtonLink
                caption="termsExceptions"
                name="administration[termsExceptions]"
                sx={{ pl: 4 }}
                title={t("menu.administration.submenu.termsExceptions.title")}
                url="/vsupplierregistration/terms_exceptions"
              >
                <ListItemText
                  primary={t(
                    "menu.administration.submenu.termsExceptions.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("Quotation Approval - Stats") && (
              <HybridRouteListItemButtonLink
                caption="quotationApprovalStats"
                name="administration[quotationApprovalStats]"
                sx={{ pl: 4 }}
                title={t(
                  "menu.administration.submenu.quotationApprovalStats.title",
                )}
                url="/vbuyer/quotations/approval_stats"
              >
                <ListItemText
                  primary={t(
                    "menu.administration.submenu.quotationApprovalStats.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}
          </List>
        </Collapse>
      </>
    );
  },
);
